import { render } from "./FAQ.vue?vue&type=template&id=b6b6d69a&scoped=true&ts=true&lang=pug"
import script from "./FAQ.vue?vue&type=script&lang=ts"
export * from "./FAQ.vue?vue&type=script&lang=ts"

import "./FAQ.vue?vue&type=style&index=0&id=b6b6d69a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6b6d69a"]])

export default __exports__